module.exports = __webpack_public_path__ + "static/media/icon-catalog-images-done.572b6696.svg";